<template>
  <div class="header">
    <a-menu mode="horizontal">
      <a-menu-item
        v-for="(v,k) in menuLeft"
        :key="k"
      >
        <router-link
          v-if="!!v.to"
          :to="v.to"
          v-html="v.title"
        ></router-link>
        <a
          v-else-if="!!v.href&&v.title=='盈展宝'"
          :href="v.href"
          class="yingzhanbaologo"
          target="_blank"
        >
        </a>
        <a
          v-else-if="!!v.href"
          :href="v.href"
          v-html="v.title"
        >
        </a>
        <a
          v-else-if="!!v.click"
          @click="v.click"
          v-html="v.title"
        ></a>
      </a-menu-item>
    </a-menu>
    <a-menu
      mode="horizontal"
      style="float:right;"
    >
      <a-menu-item
        v-for="(v,k) in menuRight"
        :key="k"
        :style="v.style"
        v-if="!v.hidden"
        style="padding:0 18px;"
        :class="v.class"
      >
        <template v-if="v.title=='反馈'">
          <a-tooltip
            arrowPointAtCenter
            autoAdjustOverflow
            placement="bottomRight"
            trigger="click"
            overlayClassName="feedback"
            v-model="feedback.visible"
          >
            <template slot="title">
              <div
                style="width:380px;height:300px;"
                class="feedback-frm"
              >
                <p class="title">
                  建议意见
                  <!-- <span class="tip">意见反馈，对于采用的建议会给予一些奖励！</span> -->
                </p>
                <p>意见或建议 <span style="color:red;">*</span></p>
                <p>
                  <a-textarea
                    :autosize="{minRows:4,maxRows:4}"
                    v-model="feedback.content"
                  ></a-textarea>
                </p>
                <p>联系方式</p>
                <p>
                  <a-input
                    placeholder="请输入电话或邮箱"
                    v-model="feedback.contact"
                  ></a-input>
                </p>
                <p>
                  <span class="error-tip">{{feedback.errorTip}}</span>
                  <a-button
                    size="large"
                    type="primary"
                    style="width:135px;border-radius:0;"
                    @click="feedbackHandle"
                  >提 交</a-button>
                </p>
              </div>
            </template>
            <div
              v-html="v.title"
              :title="v.title"
              style="margin:0 20px;color:#bae2f8;"
            ></div>
          </a-tooltip>
        </template>
        <router-link
          v-else-if="!!v.to"
          :to="v.to"
          v-html="v.title"
        ></router-link>
        <a
          v-else-if="!!v.href"
          :href="v.href"
          v-html="v.title"
        ></a>
        <a
          v-else-if="!!v.click"
          @click="v.click"
          v-html="v.title"
        ></a>
        <span
          v-else
          v-html="v.title"
          :title="v.title"
        ></span>
      </a-menu-item>
    </a-menu>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  beforeCreate() {
    this.$http
      .post("/zzAccountInfo", {
        token: this.$cookies.get("access-token") || ""
      })
      .then(res => {
        if (!res.error) {
          this.SetAccountInfo(res.data);
          this.menuRight[0].hidden = false;
          this.menuRight[0].title = res.data.nickname;
          this.menuRight[1].hidden = false;
          this.menuRight[2].hidden = true;
          this.menuRight[3].hidden = true;
          this.menuRight[4].hidden = true;
        }
      })
      .catch(() => {
        console.log("error");
      });
  },
  watch: {
    "feedback.visible"(v) {
      this.feedback = {
        visible: v,
        errorTip: "",
        contact: "",
        content: ""
      };
    }
  },
  methods: {
    ...mapActions(["SetAccountInfo"]),
    logout() {
      this.$cookies.remove("access-token", "/");
      this.$store.state.accountInfo=undefined;
      this.menuRight[0].title ="";
      this.menuRight[0].hidden = true;
      this.menuRight[1].hidden = true;
      this.menuRight[2].hidden = false;
      this.menuRight[3].hidden = false;
      this.menuRight[4].hidden = false;
      this.$router.push({path:'/'});
    },
    feedbackHandle() {
      if (!this.feedback.content) {
        return (this.feedback.errorTip = "内容不能为空。");
      }
      if (!this.feedback.contact) {
        return (this.feedback.errorTip = "联系方式不能为空。");
      }

      this.$http
        .post("/zzFeedBack", {
          suggestion: this.feedback.content,
          contact: this.feedback.contact
        })
        .then(res => {
          console.log(res);
        });
      this.feedback.visible = false;
    }
  },
  data() {
    return {
      feedback: {
        visible: false,
        errorTip: "",
        contact: "",
        content: ""
      },
      menuLeft: [
        { to: { name: "index" }, title: "首页" },
        { to: { name: "product" }, title: "产品体系介绍" },
        { to: { name: "buyerfinder",query:{st:2}}, title: "国外展会名录" },
        {to: { name: "buyerfinder",query:{st:0}},title: "国外采购商"},
        {href: 'https://discovery.showguide.cn',title: "盈展宝"},
        // { to: { name: "about" }, title: "关于我们" }
      ],
      menuRight: [
        {
          hidden: true,
          to: { name: "dashboard" },
          class: { nickname: true },
          title: "",
          style: {
            backgroundColor: "#ffffff25",
            maxWidth: "80px",
            overflow: "hidden",
            wordBreak: "break-all",
            textOverflow: "ellipsis",
            paddingRight: "10px",
            marginRight: "0"
          }
        },
        {
          hidden: true,
          title: "退出",
          click: () => {
            this.logout();
          },
          style: {
            paddingLeft: "0",
            backgroundColor: "#ffffff25"
          }
        },
        {
          click: () => {
            this.$loginFrm();
          },
          title: "登录",
          style: {
            backgroundColor: "#ffffff25"
          }
        },
        {
          title: "|",
          class: ["divider"],
          style: { padding: "0", backgroundColor: "#ffffff25" }
        },
        {
          to: { name: "register" },
          title: "注册",
          style: {
            backgroundColor: "#ffffff25"
          }
        },
        {
          to: { name: "updatelogs" },
          title: "更新日志",
          style: {
            'margin-left': "20px",
            padding: "0",
            color: "#007cbe"
          }
        },
        {
          click() {
            console.log("反馈");
          },
          title: "反馈",
          style: {
            padding: "0",
            color: "#007cbe"
          }
        },
      ]
    };
  }
};
</script>
<style lang="scss" scoped>
.header {
  text-align: left;
  height: 32px;
  // background: #072c4b !important;
  background: url("~@/assets/img/header_bg.jpg");
  // border-bottom: 1px solid #e8e8e8;
  .ant-menu {
    color: #fff;
    background: #ffffff00 !important;
    display: inline-block;
    line-height: 32px;
    border: none;
    font-size: 12px;
    .ant-menu-item {
      padding: 0 16px;
    }
    .nickname {
      a {
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
    .ant-menu-item,
    .ant-menu-item > a,
    .ant-menu-item-selected,
    .ant-menu-item-selected > a {
      border: none !important;
      color: #bae2f8;
    }
  }
  .yingzhanbaologo{
    background: url("~@/assets/img/yingzhanbaoLogo.svg");
    width: 60px;
    height: 19px;
    display: inline-block;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
    top: 6px;
  }
}
</style>
<style lang="scss" >
.feedback {
  min-width: 440px;
  .ant-tooltip-content {
    min-width: 440px;
    .ant-tooltip-arrow {
      border-bottom-color: #fff;
    }
    .ant-tooltip-inner {
      min-width: 440px;
      background-color: #fff;
      border-radius: 0;
      border-left: 6px solid #000;
      border-image: linear-gradient(to top, #0496e2, #056197, #072d4d) 1 1;
      .feedback-frm {
        margin: 20px;
        color: #000;
        p {
          font-size: 13px;
        }
        p:last-child {
          text-align: right;
          .error-tip {
            color: #ff4242;
            font-size: 12px;
            margin-right: 20px;
          }
        }
        .title {
          font-size: 16px;
          font-weight: bold;
          .tip {
            font-weight: normal;
            display: block;
            font-size: 13px;
            color: #e5a304;
          }
        }
      }
    }
  }
}
</style>
